<template>
  <el-dialog title="物流码明细" :visible="true" width="60%" :before-close="handleClose">
    <!--表格-->
    <el-table ref="multipleTable" :data="tableData" v-loading="loading" border stripe height="250" style="width: 100%">
      <el-table-column prop="code_name" label="标签类型" width="180" fixed>
      </el-table-column>
      <el-table-column prop="logistics_code" label="物流码" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="real_stock_in_num" label="数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin: 20px 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize">
    </el-pagination>

  </el-dialog>
</template>

<script>
export default {
  name: "instock-detail",
  props: {
    detailData: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      tableData: [],
    };
  },
  methods: {
    getData() {
      let url = "/inwarehouses/" + this.detailData + "/datas";
      this.loading = true;
      this.$get("logistics", url, {
        per_page: this.pageSize,
        page: this.pageNo,
        inwarehouse: this.detailData,
        lang: "",
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function (error) {
          this.loading = false;
          console.log(error);
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getData();
    },
    handleClose() {
      this.$emit("handleClose");
    },
    del(data) {
      this.$confirm("是否要回退?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url =
            "inwarehouses/" +
           this.detailData +
            "?logistics_code=" +
            data.logistics_code;
          this.$delete("pda", url,{data:{ channel: 1 }})
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              if(this.tableData.length>1){
                this.getData();
              }else{
                  this.$emit('done')
              } 
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
</style>